'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
// import '../icon.css'


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

require('../fa.css');

var _reactFontawesome = require('react-fontawesome');

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _reactHtmlParser = require('react-html-parser');

var _reactHtmlParser2 = _interopRequireDefault(_reactHtmlParser);

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import HkbnesIcon from '../hkbnesIcon'

function NavItemMobile(props) {
    var itemIndex = props.itemIndex,
        itemContent = props.itemContent,
        handleItemClick = props.handleItemClick,
        handleMouseEnter = props.handleMouseEnter,
        isActive = props.isActive,
        onURLClick = props.onURLClick;

    var _useState = (0, _react.useState)(),
        _useState2 = _slicedToArray(_useState, 2),
        activeItemLV1 = _useState2[0],
        setActiveItemLV1 = _useState2[1];

    var _useState3 = (0, _react.useState)(),
        _useState4 = _slicedToArray(_useState3, 2),
        activeItemLV2 = _useState4[0],
        setActiveItemLV2 = _useState4[1];

    var _useState5 = (0, _react.useState)(null),
        _useState6 = _slicedToArray(_useState5, 2),
        updateScrollPosition = _useState6[0],
        setUpdateScrollPosition = _useState6[1];

    var devRef = (0, _react.useRef)();

    var renderArrow = function renderArrow(item, itemIsActive, hasNextLevel) {
        if (!_lodash2.default.isEmpty(item.content) && item.content !== false && hasNextLevel) {
            return itemIsActive ? _react2.default.createElement(_reactFontawesome2.default, { name: 'angle-up' }) : _react2.default.createElement(_reactFontawesome2.default, { name: 'angle-down' });
        }
    };

    var handleScrollOnClick = function handleScrollOnClick(level, nodeIndex) {
        if (devRef.current) {
            var divOffsetTop = level == 0 ? (0, _lodash.get)(devRef, "current.children[0].offsetTop", 0) : (0, _lodash.get)(devRef, 'current.children[1].children[' + nodeIndex + '].offsetTop');
            if (document.getElementById("mobile-menu").scrollTop > divOffsetTop) {
                document.getElementById("mobile-menu").scrollTo(0, divOffsetTop, { behaviour: 'smooth' });
            }
        }
    };

    (0, _react.useEffect)(function () {
        if (updateScrollPosition) {
            var lv2Key = (0, _lodash.get)(updateScrollPosition, "lv2Key", 0) == 0 ? 0 : (0, _lodash.get)(updateScrollPosition, "lv2Key", 0) + 1;
            var nodeIndex = (0, _lodash.get)(updateScrollPosition, "lv1Key", 0) + lv2Key;
            handleScrollOnClick(updateScrollPosition.level, nodeIndex);
        }
    }, [updateScrollPosition]);
    return _react2.default.createElement(
        'div',
        { ref: devRef },
        _react2.default.createElement(
            'div',
            {
                className: 'item d-flex justify-content-between p-3 align-items-center ' + (isActive ? "subIsActive" : "subIsNotActive"),
                onClick: function onClick() {
                    if (!_lodash2.default.isEmpty(itemContent.subNav.content)) {
                        var selectedItemContent = isActive ? null : itemContent;
                        var selectedItemIndex = isActive ? null : itemIndex;
                        handleMouseEnter(selectedItemContent, selectedItemIndex);
                        setUpdateScrollPosition({ level: 0 });
                    } else if (!(0, _isEmpty2.default)(itemContent.url)) {
                        props.onURLClick(itemContent.url, 'mainNav');
                        props.setSubNavLV2Index(null);
                        props.setShowMobileMenu(false);
                    }
                },
                style: { color: itemContent.color, backgroundColor: itemContent.bgColor }
            },
            _react2.default.createElement(
                'div',
                { className: 'd-flex align-items-center' },
                _react2.default.createElement(
                    'div',
                    { className: 'title' },
                    _react2.default.createElement(
                        'h3',
                        { className: 'mb-0' },
                        _react2.default.createElement(
                            'div',
                            { className: 'd-flex', onClick: function onClick(e) {
                                    if (!_lodash2.default.isEmpty(itemContent.url)) {
                                        e.stopPropagation();
                                        props.onURLClick(itemContent.url, 'mainNav');
                                        props.setSubNavLV2Index(null);
                                        props.setShowMobileMenu(false);
                                    }
                                } },
                            _react2.default.createElement('div', null),
                            '\xA0\xA0',
                            (0, _reactHtmlParser2.default)(itemContent.title)
                        )
                    )
                )
            ),
            !_lodash2.default.isEmpty(itemContent.subNav) && (0, _lodash.get)(itemContent, "subNav.content", false) && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'icon right-arrow' },
                    renderArrow(itemContent.subNav, isActive, (0, _lodash.get)(itemContent, "subNav.content", []).length > 0)
                )
            )
        ),
        _react2.default.createElement(
            'div',
            { className: 'sub-nav' },
            !_lodash2.default.isEmpty(itemContent.subNav) && isActive && itemContent.subNav.content && itemContent.subNav.content.map(function (item, key) {
                return _react2.default.createElement(
                    _react2.default.Fragment,
                    { key: key },
                    _react2.default.createElement(
                        'div',
                        {
                            key: key,
                            style: { backgroundColor: "#f0f0f0" }
                        },
                        _react2.default.createElement(
                            'div',
                            {
                                className: 'd-flex align-items-center p-3 justify-content-between item ' + (activeItemLV1 == key ? "subIsActiveLV1" : "subIsNotActive"),
                                style: { width: 'calc(100% - 5px)', marginLeft: "5px" },
                                onClick: function onClick(e) {
                                    if ((0, _lodash.get)(item, "subNav.content", []).length > 0) {
                                        setActiveItemLV1(activeItemLV1 == key ? null : key);
                                        setActiveItemLV2(null);
                                        setUpdateScrollPosition({ level: 1, lv1Key: key });
                                    } else if ((0, _lodash.get)(item, "url", "") != "") {
                                        props.onURLClick(item.url, 'subNav1');
                                        props.setShowMobileMenu(false);
                                        props.setSubNavLV2Index(null);
                                    }
                                }
                            },
                            _react2.default.createElement(
                                'a',
                                {
                                    href: item.url,
                                    onClick: function onClick(e) {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        if ((0, _lodash.get)(item, "url", "") != "") {
                                            props.onURLClick(item.url, 'subNav1');
                                            props.setShowMobileMenu(false);
                                            props.setSubNavLV2Index(null);
                                        } else {
                                            setActiveItemLV1(activeItemLV1 == key ? null : key);
                                            setActiveItemLV2(null);
                                        }
                                    }
                                },
                                (0, _reactHtmlParser2.default)(item.title)
                            ),
                            '\xA0\xA0',
                            _react2.default.createElement(
                                'div',
                                { className: 'icon right-arrow' },
                                renderArrow(item.subNav, activeItemLV1 == key, (0, _lodash.get)(item, "subNav.content", []).length > 0)
                            )
                        )
                    ),
                    (0, _lodash.get)(itemContent, 'subNav.content[' + activeItemLV1 + '].subNav', null) && activeItemLV1 == key && itemContent.subNav.content[activeItemLV1].subNav.content.map(function (lv2Item, lv2Key) {
                        // console.log(lv2Item)
                        return _react2.default.createElement(
                            _react2.default.Fragment,
                            { key: lv2Key },
                            _react2.default.createElement(
                                'div',
                                {
                                    key: lv2Key,
                                    style: { width: 'calc(100% - 15px)', marginLeft: "15px" }
                                },
                                _react2.default.createElement(
                                    'div',
                                    {
                                        className: 'd-flex align-items-center p-3 justify-content-between itemLV2 ' + (activeItemLV2 == lv2Key ? "subIsActiveLV2" : "subIsNotActive"),
                                        onClick: function onClick(e) {
                                            if ((0, _lodash.get)(lv2Item, "subNav.content", []).length > 0) {
                                                setActiveItemLV2(activeItemLV2 == lv2Key ? null : lv2Key);
                                                setUpdateScrollPosition({ level: 2, lv1Key: key, lv2Key: lv2Key });
                                            } else {
                                                props.onURLClick(lv2Item.url, 'subNav2');
                                                props.setShowMobileMenu(false);
                                                props.setSubNavLV2Index(null);
                                            }
                                        }
                                    },
                                    _react2.default.createElement(
                                        'a',
                                        {
                                            href: lv2Item.url,
                                            onClick: function onClick(e) {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                if ((0, _lodash.get)(lv2Item, "url", "") != "") {
                                                    props.onURLClick(lv2Item.url, 'subNav2');
                                                    props.setShowMobileMenu(false);
                                                    props.setSubNavLV2Index(null);
                                                } else {
                                                    setActiveItemLV2(activeItemLV2 == lv2Key ? null : lv2Key);
                                                }
                                            }
                                        },
                                        (0, _reactHtmlParser2.default)(lv2Item.title)
                                    ),
                                    '\xA0\xA0',
                                    renderArrow(lv2Item.subNav, activeItemLV2 == lv2Key, lv2Item.subNav != null)
                                )
                            ),
                            (0, _lodash.get)(itemContent, 'subNav.content[' + activeItemLV1 + '].subNav.content[' + activeItemLV2 + '].subNav.content', null) && activeItemLV2 == lv2Key && itemContent.subNav.content[activeItemLV1].subNav.content[activeItemLV2].subNav.content.map(function (lv3Item, lv3Key) {
                                // console.log(lv3Item)
                                return _react2.default.createElement(
                                    _react2.default.Fragment,
                                    { key: lv3Key },
                                    _react2.default.createElement(
                                        'div',
                                        {
                                            key: lv3Key,
                                            style: { width: 'calc(100% - 15px)', marginLeft: "15px" }
                                        },
                                        _react2.default.createElement(
                                            'div',
                                            {
                                                className: 'd-flex align-items-center p-3 itemLV2 ' + (activeItemLV2 == lv2Key ? "subIsActiveLV2" : "subIsNotActive"),
                                                onClick: function onClick(e) {
                                                    props.onURLClick(lv3Item.url, 'subNav3');
                                                    props.setShowMobileMenu(false);
                                                    props.setSubNavLV2Index(null);
                                                }
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                { href: lv3Item.url, onClick: function onClick(e) {
                                                        e.preventDefault();
                                                    } },
                                                (0, _reactHtmlParser2.default)(lv3Item.title)
                                            ),
                                            '\xA0\xA0'
                                        )
                                    )
                                );
                            })
                        );
                    })
                );
            })
        )
    );
}

exports.default = NavItemMobile;